export enum TransactionState {
  Failed = 'Failed',
  Confirm = 'Confirm',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Submitted = 'Submitted',
  Confirming = 'Confirming',
  InProgress = 'in-progress',
  RequestingVAA = 'RequestingVAA',
  FailedCancelled = 'failed-cancelled',
  EthereumConfirming = 'EthereumConfirming',
  InjectiveConfirming = 'InjectiveConfirming'
}
